// utils/apiHelpers.js
// Helper per gestire le chiamate API con tenant

/**
 * Restituisce gli headers necessari per le chiamate API con tenant
 */
export const getApiHeaders = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('tenant_token');
  const headers = { 'Authorization': `Bearer ${token}` };
  
  let tenantDb = localStorage.getItem('tenant_db');
  
  // Fallback: prova tenant_list
  if (!tenantDb) {
    try {
      const tenantList = JSON.parse(localStorage.getItem('tenant_list') || '[]');
      if (tenantList.length > 0 && tenantList[0].database_name) {
        tenantDb = tenantList[0].database_name;
      }
    } catch (e) {
      console.debug('Error parsing tenant_list:', e);
    }
  }
  
  // Fallback: prova tenant_user
  if (!tenantDb) {
    try {
      const tenantUser = JSON.parse(localStorage.getItem('tenant_user') || '{}');
      if (tenantUser.tenants && tenantUser.tenants[0]) {
        tenantDb = tenantUser.tenants[0].database_name;
      }
    } catch (e) {
      console.debug('Error parsing tenant_user:', e);
    }
  }
  
  // Aggiungi header solo se abbiamo un tenant
  if (tenantDb) {
    // Rimuovi prefisso tenant_ se presente
    headers['X-Tenant-DB'] = tenantDb.replace(/^tenant_/, '');
  }
  
  return headers;
};

/**
 * Restituisce il token di autenticazione
 */
export const getAuthToken = () => {
  return localStorage.getItem('token') || localStorage.getItem('tenant_token');
};

/**
 * Restituisce il database name del tenant corrente
 */
export const getTenantDb = () => {
  let tenantDb = localStorage.getItem('tenant_db');
  
  if (!tenantDb) {
    try {
      const tenantList = JSON.parse(localStorage.getItem('tenant_list') || '[]');
      if (tenantList.length > 0 && tenantList[0].database_name) {
        tenantDb = tenantList[0].database_name;
      }
    } catch (e) {}
  }
  
  if (!tenantDb) {
    try {
      const tenantUser = JSON.parse(localStorage.getItem('tenant_user') || '{}');
      if (tenantUser.tenants && tenantUser.tenants[0]) {
        tenantDb = tenantUser.tenants[0].database_name;
      }
    } catch (e) {}
  }
  
  return tenantDb;
};
